export default "__VITE_ASSET__wtM1vsYb__"